import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-find-results-count',
  templateUrl: './pdf-find-results-count.component.html',
  styleUrls: ['./pdf-find-results-count.component.css']
})
export class PdfFindResultsCountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
